import {
  yesNoUI,
  yesNoSchema,
} from 'platform/forms-system/src/js/web-component-patterns';

/** @type {PageSchema} */
export default {
  uiSchema: {
    howMarriageEndedDivorce: yesNoUI({
      title: 'Did your marriage end in divorce?',
      labelHeaderLevel: '3',
    }),
  },
  schema: {
    type: 'object',
    required: ['howMarriageEndedDivorce'],
    properties: {
      howMarriageEndedDivorce: yesNoSchema,
    },
  },
};
